import { FieldsOptions } from '@sim/form';
import { FilterFieldsOptions } from '@ui/ui.module';

import { CardRelation, CardRelationMeta, ICCDMeta } from './card';
import { RelationDMeta, RelationFMeta, RelationMIMeta, RelationOAMeta, RelationSMeta } from './relation';

// tslint:disable-next-line:no-empty-interface
export interface CardMI extends CardRelation {

}

export interface CardMIFilter {
  codiceUnico?: string;
  ['SGT.SGTT']?: string;
}

export const CardMIFiltersMeta: FilterFieldsOptions<CardMIFilter> = {
  codiceUnico: { operator: 'begins_with' },
  ['SGT.SGTT']: { operator: 'begins_with' },
};

export const CardMIMeta: FieldsOptions<any> = {
  ...CardRelationMeta,
  AUT: { ...ICCDMeta.AUT, value: [{ AUTN: 'Igor Mitoraj', AUTA: 'Oederan, 26 marzo 1944 – Parigi, 6 ottobre 2014' }] },
  TSK: { ...ICCDMeta.TSK, value: 'MI' },
  relazioniBeniD: { type: 'array', controls: RelationDMeta, value: [] },
  relazioniBeniF: { type: 'array', controls: RelationFMeta, value: [] },
  relazioniBeniMI: { type: 'array', controls: RelationMIMeta, value: [] },
  relazioniBeniOA: { type: 'array', controls: RelationOAMeta, value: [] },
  relazioniBeniS: { type: 'array', controls: RelationSMeta, value: [] },
};
